import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const ENERGYSOURCE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.EnergySource.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.EnergySource.Code')
    .required()
    .maxLength(20)
    .build(),
  FieldBuilder
    .text('ducsaCode', 'Entity.EnergySource.DucsaCode')
    .maxLength(20)
    .build(),
];

export const ENERGYSOURCE_CONFIG = {
  entityName: 'EnergySource',
  localizationKey: 'General::Entity.EnergySource',
  fields: ENERGYSOURCE_FIELDS,
  permission: 'ControllingLiquidations.EnergySources',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
